// @flow
import Component from './component'
export default () => ({
  path: 'dcf-report-view',
  element: <Component />,
})
